import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { environment } from '../../environments/environment';

import { HistoryService } from '../history.service';
import { ProcessInstance } from '../process-instance';
import { QueryMetaData} from '../query-metadata';
import { RuntimeService } from '../runtime.service';
import { PaginationComponent } from '../pagination/pagination.component';

@Component({
    selector: 'app-proc-inst-list',
    templateUrl: './proc-inst-list.component.html',
    styleUrls: ['./proc-inst-list.component.scss'],
    standalone: true,
    imports: [RouterModule, CommonModule, PaginationComponent]
})
export class ProcInstListComponent implements OnInit {

  procInsts: ProcessInstance[];
  selectedProcInst: ProcessInstance;
  procInst: ProcessInstance;
  query: QueryMetaData;
  active: boolean;

  private historyService: HistoryService = inject(HistoryService);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private runtimeService: RuntimeService = inject(RuntimeService);

  ngOnInit(): void {
    this.route.queryParamMap
      .subscribe((params) => {
               const start = params.get('start') === null ? 0 : parseInt(params.get('start'));
               const size = params.get('size') === null ? environment.pageSize : parseInt(params.get('size'));
        this.query = { start, size } as QueryMetaData;
        this.active = params.get('active') === null ? true : params.get('active') === 'active';
        if (this.active) {
          this.getProcessInstances(this.query);
        } else {
          this.getHistoricProcessInstances(this.query);
        }
      }
    );
  }

  getProcessInstances(query: QueryMetaData): void {
    this.runtimeService.getProcessInstances(query)
        .subscribe(procInsts => this.procInsts = procInsts);
  }

  getHistoricProcessInstances(query: QueryMetaData): void {
    this.historyService.getHistoricProcessInstances(query)
        .subscribe(procInsts => this.procInsts = procInsts);
  }

}
